export default "__VITE_ASSET__1f7e93e8__"